// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * User contact information for notification delivery.
 */
export class ContactInfo implements flatbuffers.IUnpackableObject<ContactInfoT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ContactInfo {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsContactInfo(bb: flatbuffers.ByteBuffer, obj?: ContactInfo): ContactInfo {
    return (obj || new ContactInfo()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsContactInfo(
    bb: flatbuffers.ByteBuffer,
    obj?: ContactInfo,
  ): ContactInfo {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ContactInfo()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  userId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  organizationId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  phone(): string;
  phone(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  phone(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  phoneCode(): string;
  phoneCode(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  phoneCode(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  address(): string;
  address(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  address(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  priority(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startContactInfo(builder: flatbuffers.Builder) {
    builder.startObject(10);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addUserId(builder: flatbuffers.Builder, userIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, userIdOffset, 0);
  }

  static addOrganizationId(builder: flatbuffers.Builder, organizationIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, organizationIdOffset, 0);
  }

  static addPhone(builder: flatbuffers.Builder, phoneOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, phoneOffset, 0);
  }

  static addPhoneCode(builder: flatbuffers.Builder, phoneCodeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, phoneCodeOffset, 0);
  }

  static addAddress(builder: flatbuffers.Builder, addressOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, addressOffset, 0);
  }

  static addPriority(builder: flatbuffers.Builder, priority: number) {
    builder.addFieldInt16(6, priority, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, deletedAtOffset, 0);
  }

  static endContactInfo(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // user_id
    builder.requiredField(offset, 8); // organization_id
    builder.requiredField(offset, 10); // phone
    builder.requiredField(offset, 12); // phone_code
    builder.requiredField(offset, 14); // address
    return offset;
  }

  unpack(): ContactInfoT {
    return new ContactInfoT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.userId() !== null ? this.userId()!.unpack() : null,
      this.organizationId() !== null ? this.organizationId()!.unpack() : null,
      this.phone(),
      this.phoneCode(),
      this.address(),
      this.priority(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
    );
  }

  unpackTo(_o: ContactInfoT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.userId = this.userId() !== null ? this.userId()!.unpack() : null;
    _o.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    _o.phone = this.phone();
    _o.phoneCode = this.phoneCode();
    _o.address = this.address();
    _o.priority = this.priority();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
  }

  unpackFields(...fields: string[]): ContactInfoT {
    const t = new ContactInfoT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("user_id")) {
      t.userId = this.userId() !== null ? this.userId()!.unpack() : null;
    }
    if (fieldSet.has("organization_id")) {
      t.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    }
    if (fieldSet.has("phone")) {
      t.phone = this.phone();
    }
    if (fieldSet.has("phone_code")) {
      t.phoneCode = this.phoneCode();
    }
    if (fieldSet.has("address")) {
      t.address = this.address();
    }
    if (fieldSet.has("priority")) {
      t.priority = this.priority();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    return t;
  }
}

export class ContactInfoT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public userId: UuidT | null = null,
    public organizationId: UuidT | null = null,
    public phone: string | Uint8Array | null = null,
    public phoneCode: string | Uint8Array | null = null,
    public address: string | Uint8Array | null = null,
    public priority: number = 0,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.userId === null || this.userId === undefined) {
      throw new Error('Required field "user_id" is not set');
    }
    if (this.organizationId === null || this.organizationId === undefined) {
      throw new Error('Required field "organization_id" is not set');
    }
    if (this.phone === null || this.phone === undefined) {
      throw new Error('Required field "phone" is not set');
    }
    if (this.phoneCode === null || this.phoneCode === undefined) {
      throw new Error('Required field "phone_code" is not set');
    }
    if (this.address === null || this.address === undefined) {
      throw new Error('Required field "address" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const userId = this.userId !== null ? this.userId!.pack(builder) : 0;
    const organizationId = this.organizationId !== null ? this.organizationId!.pack(builder) : 0;
    const phone = this.phone !== null ? builder.createString(this.phone!) : 0;
    const phoneCode = this.phoneCode !== null ? builder.createString(this.phoneCode!) : 0;
    const address = this.address !== null ? builder.createString(this.address!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;

    ContactInfo.startContactInfo(builder);
    ContactInfo.addId(builder, id);
    ContactInfo.addUserId(builder, userId);
    ContactInfo.addOrganizationId(builder, organizationId);
    ContactInfo.addPhone(builder, phone);
    ContactInfo.addPhoneCode(builder, phoneCode);
    ContactInfo.addAddress(builder, address);
    ContactInfo.addPriority(builder, this.priority);
    ContactInfo.addCreatedAt(builder, createdAt);
    ContactInfo.addUpdatedAt(builder, updatedAt);
    ContactInfo.addDeletedAt(builder, deletedAt);

    return ContactInfo.endContactInfo(builder);
  }

  clone(): ContactInfoT {
    const obj = new ContactInfoT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.userId = this.userId !== null ? this.userId!.clone() : null;
    obj.organizationId = this.organizationId !== null ? this.organizationId!.clone() : null;
    obj.phone = this.phone;
    obj.phoneCode = this.phoneCode;
    obj.address = this.address;
    obj.priority = this.priority;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    return obj;
  }

  equals(other: ContactInfoT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.userId !== null && other.userId !== null) {
      if (!this.userId!.equals(other.userId!)) return false;
    } else if (this.userId !== other.userId) return false;
    if (this.organizationId !== null && other.organizationId !== null) {
      if (!this.organizationId!.equals(other.organizationId!)) return false;
    } else if (this.organizationId !== other.organizationId) return false;
    if (this.phone !== other.phone) return false;
    if (this.phoneCode !== other.phoneCode) return false;
    if (this.address !== other.address) return false;
    if (this.priority !== other.priority) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    return true;
  }
}

export function verifyContactInfo(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "user_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "organization_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "phone");
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 12, "phone_code");
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 14, "address");
    verifier.checkScalarField(tablePos, 16, 2);
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
